import React, { Component } from 'react';

export default class CustomDateInput extends Component {
  render () {
    return (
      <input readOnly={ true } type="text" value={ this.props.value } onClick={ this.props.onClick } name={ this.props.name }  />
    )
  }
}
